<template>
	<template v-if="appLink !== '#'">
		<it-link :to="appLink"><slot></slot></it-link>
	</template>
	<a v-else href="#" @click.prevent="invokeAction" class="cell-click"><slot></slot></a>
</template>

<script setup lang="ts">
import {injectCellAPI, RowContext, rowContextKey} from "@fd/containers/agenda/AgendaUtils.ts";
import {computed, inject, ref, watchEffect} from "vue";
import {Column} from "@t/agenda/Columns.ts";
import ItLink from "@/router/ItLink.vue";
import {injectEnv} from "@fd/Environment.ts";
import {injectContext} from "@t/fd/AppContext.ts";

const props = defineProps<{
	/** Name of an action to be invoked on CellAPI */
	action: string;
	/** Object with data for the row */
	object: object;
	srcType?: number;
	data: Record<string, any>;
	/** Column specs */
	col: Column;
}>();
defineOptions({ name: 'cell-click' });

const api = injectCellAPI();
const env = injectEnv();
const rowContext = inject(rowContextKey);

function invokeAction(e:MouseEvent) {
	api.action(props.action, props.srcType, props.data, rowContext.value, e);
}

const appLink = ref<string>("#");

async function buildAppLink(srcType:number, srcId:number|string) {
	const url = await env.urlTo(srcType, srcId);
	appLink.value = url;
}

watchEffect(() => {
	if (props.srcType && typeof props.data.id !== 'undefined') {
		//console.log("CellClick: data = "+JSON.stringify(props.data));
		buildAppLink(props.srcType, props.data.id);
	}
});

</script>

<style>
.cell-click {
	user-select: none;
	-webkit-user-select: none;
}
</style>